import React, {useEffect} from 'react';
import { Route, Routes} from 'react-router-dom';
import Calendar from "./Routes/Calendar";
import {ToastContextProvider} from "./ToastContext";
import LoginPage from "./Routes/Login";
import AdminRoute from "./hooks/AdminRoute";
import LogsPage from "./Routes/Logs";
import LeadConfigPage from "./Routes/LeadConfig";
import NormalRoute from "./hooks/NormalRoute";

const Controller = () => {


    return (
        <Routes>
            <Route path="/" element={<NormalRoute><Calendar /></NormalRoute>} />
            <Route path="/login" element={<ToastContextProvider><LoginPage /></ToastContextProvider>} />
            <Route path="/logs" element={<AdminRoute><LogsPage /></AdminRoute>} />
            <Route path="/lead" element={<AdminRoute><LeadConfigPage /></AdminRoute>} />
        </Routes>
    );
}

export default Controller;
